// import { mapState } from 'vuex'

export default {
  name: 'side-nav',
  methods: {
    clickD1 (item) {
      if (
        this.selectedProgram === item.title.toLowerCase() &&
        this.expanded
      ) {
        this.setSideNavState(false)
      } else {
        this.setSideNavState(true)
        this.setSubItem(item)
        this.selectedProgram = item.title.toLowerCase()
      }
    },
    getNavItems () {
      // TODO: navStore의 action 실행
    },
    pathName (depth) {
      return this.$route.path.split('/')[depth]
    },
    /* getSubItem (name = 'spc') {
      console.warn('DEPRECATED: login API 붙이면서 이제 안써유. setSubItem 쓰세요')
      if (trees[name]) {
        this.subItem = trees[name]
        this.subItem.items.forEach(item => {
          item.expanded = false
        })
      } else {
        this.$nextTick(function () {
          this.$store.dispatch('setSideNav', false)
        })
      }
      // console.log('@getSubItem', this.subItem)
    }, */
    setSubItem (item = {}) {
      this.subItem = item
    },
    toggleItem (item, parent) {
      parent.forEach(item => {
        if (item.children) item.expanded = false
      })
      item.expanded = true
      this.$forceUpdate()
    },
    setSideNavState (val = undefined) {
      this.expanded = (val === undefined) ? !this.expanded : val
      // console.log('@sideNavSatus', val, '=>', this.expanded)
      // this.$store.dispatch('setSideNav', expanded)
    },
    routerPush (to = '', program = {}, target = '_self') {
      // console.log('@routerPush', to)
      this.setSideNavState(false)
      if (target === '_blank') {
        // let route = this.$router.resolve({ name: to })
        window.open(to, target)
      } else {
        this.$router.push({ path: to, params: { program: program } })
      }
      // this.$store.dispatch('resetGlobalSearch')
    },
    bookmarkToggle (e, node) {
      e.stopPropagation()
      node.bookMark = node.bookMark !== true
      if (node.bookMark) {
        this.$store.dispatch('addBookmark', node)
      } else {
        this.$store.dispatch('deleteBookmark', node)
      }
      this.$refs.tree.$forceUpdate()
    },
    makeupNode (node, options) {
      Object.assign(node, options)
      node.title = (
        <span class="side-nav-title">
          <span>{node.title}</span>
          <span
            class="open-in-new"
            onClick={e => {
              this.nodeLink(e, node, '_blank')
            }}
          >
            <b-icon
              icon="open-in-new"
              size="is-small"
            />
          </span>
        </span>
      )
      node.click = e => {
        this.nodeLink(e, node)
      }
      if (node.children && node.children.length) {
        node.children.forEach(childNode => {
          this.makeupNode(childNode, options)
        })
      }
      return node
    },
    nodeLink (event = {}, node = {}, target = undefined) {
      event.stopPropagation()
      event.preventDefault()

      if (node.url === '/fdc/classification/fault-classification' ||
          node.url === '/fdc/classification/fault-class-register') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_UNDER_DEVELOPMENT'))
      } else {
        if (node.children && node.children.length) {
          node.isCollapsed = !node.isCollapsed
        } else {
          // if (
          //   this.selectedProgram === this.subDomain ||
          //   process.env.NODE_ENV !== 'production'
          // ) {
          //   this.routerPush(node.url, node, target)
          // } else {
          //   let href = process.env.VUE_APP_HTTPS_ENABLE === 'true' ? `https://${this.subDomains[this.selectedProgram.toLowerCase()]}.${this.theDomain}${node.url}` : `http://${this.subDomains[this.selectedProgram.toLowerCase()]}.${this.theDomain}${node.url}`
          //   if (!target) document.location.href = href
          //   else window.open(href, target)
          // }
          this.routerPush(node.url, node, target)
        }
      }
    }
  },
  watch: {
    programs (newval) {
      console.log('@watch:program', newval)
      newval.forEach(d1 => {
        d1.children.forEach(d2 => {
          d2 = this.makeupNode(d2, {
            class: 'nav-item'
          })
        })
      })
    }
  },
  computed: {
    // ...mapState({
    //   sideNavExpanded: state => state.ui.sideNavExpanded
    // })
  },
  mounted () {
    this.programs.forEach(d1 => {
      d1.children.forEach(d2 => {
        d2 = this.makeupNode(d2, {
          class: 'nav-item'
        })
      })
    })
  },
  data () {
    return {
      selectedProgram: null,
      expanded: false,
      columns: [
        { label: '프로그램', field: 'program' },
        { label: '북마크', field: 'bookmark', width: '40px' }
      ],
      subItem: {},
      programs: [
        // {
        //   // progrmIndex: 98,
        //   title: 'FDC',
        //   url: '/fdc',
        //   // progrmSubnet: 'fdc',
        //   progrmHist: '/FDC',
        //   progrmPictr: 'monitor-dashboard',
        //   // progrmRoot: 98,
        //   // progrmUpper: 0,
        //   // progrmLevel: 1,
        //   children: [
        {
          title: 'Dashboard',
          menutTitle: 'Board',
          url: '/fdc/dashboard',
          progrmHist: '/FDC/Dashboard',
          progrmClass: 'dashboard',
          children: [
            {
              title: 'Dashboard',
              url: '/fdc/dashboard/dashboard',
              progrmHist: '/FDC/Dashboard/Dashboard',
              children: []
            }
          ]
        },
        {
          // progrmIndex: 158,
          title: 'Base Info',
          menutTitle: 'Base Info',
          url: '/fdc/base-info',
          progrmHist: '/FDC/Base Info',
          progrmClass: 'baseinfo',
          // progrmPictr: 'alpha-i-box-outline',
          // progrmUpper: 98,
          // progrmRoot: 98,
          // progrmLevel: 2,
          // bookMark: false,
          children: [
            {
              // progrmIndex: 159,
              title: 'FAB Info',
              url: '/fdc/base-info/fab-info',
              progrmHist: '/FDC/Base Info/FAB Info',
              // progrmUpper: 158,
              // progrmRoot: 98,
              // progrmLevel: 3,
              // progrmOrdr: 1,
              // bookMark: false,
              children: []
            },
            // {
            //   title: 'Group Info',
            //   url: '/fdc/base-info/group-info',
            //   progrmHist: '/FDC/Base Info/Group Info',
            //   children: []
            // },
            // {
            //   title: 'Group Param Info',
            //   url: '/fdc/base-info/group-param-info',
            //   progrmHist: '/FDC/Base Info/Group Param Info',
            //   children: []
            // },
            {
              // progrmIndex: 170,
              title: 'EQP Info',
              url: '/fdc/base-info/eqp-info',
              progrmHist: '/FDC/Base Info/EQP Info',
              // progrmUpper: 158,
              // progrmRoot: 98,
              // progrmLevel: 3,
              // progrmOrdr: 2,
              // bookMark: false,
              children: []
            },
            {
              title: 'EQP Event Info',
              url: '/fdc/base-info/eqp-event-info',
              progrmHist: '/FDC/Base Info/EQP Event Info',
              children: []
            },
            {
              title: 'EQP Recipe Info',
              url: '/fdc/base-info/eqp-recipe-info',
              progrmHist: '/FDC/Base Info/EQP Recipe Info',
              children: []
            },
            {
              title: 'EQP Param Info',
              url: '/fdc/base-info/eqp-param-info',
              progrmHist: '/FDC/Base Info/EQP Param Info',
              children: []
            },
            {
              title: 'Virtual Parameter',
              url: '/fdc/base-info/virtual-parameter',
              progrmHist: '/FDC/Base Info/Virtual Parameter',
              children: []
            }
            // {
            //   title: 'EQP Context Info',
            //   url: '/fdc/base-info/eqp-context-info',
            //   progrmHist: '/FDC/Base Info/EQP Context Info',
            //   children: []
            // }
          ]
        },
        {
          title: 'Collection',
          menutTitle: 'Collect',
          url: '/fdc/collection',
          progrmClass: 'collection',
          children: [
            {
              title: 'Data Collection Plan',
              url: '/fdc/collection/data-collection-plan',
              children: []
            },
            {
              title: 'Event Collection Plan',
              url: '/fdc/collection/event-collection-plan',
              children: []
            },
            {
              title: 'Trace Collection Plan',
              url: '/fdc/collection/trace-collection-plan',
              children: []
            },
            {
              title: 'Context Mapping Plan',
              url: '/fdc/collection/context-mapping-plan',
              children: []
            }
            // {
            //   title: 'Data Summary Plan',
            //   url: '/fdc/collection/data-summary-plan',
            //   children: []
            // }
          ]
        },
        {
          title: 'Preprocessing',
          menutTitle: 'Prep',
          url: '/fdc/pre-processing',
          progrmClass: 'preprocessing',
          children: [
            {
              title: 'Preprocessing Plan',
              url: '/fdc/pre-processing/pre-processing-plan',
              children: []
            },
            {
              title: 'Data Summary Plan',
              url: '/fdc/pre-processing/data-summary-plan',
              children: []
            }
          ]
        },
        {
          title: 'Monitor',
          menutTitle: 'Monitor',
          url: '/fdc/monitor',
          progrmClass: 'monitor',
          children: [
            // {
            //   title: 'Dashboard',
            //   url: '/fdc/monitor/dashboard',
            //   children: []
            // },
            {
              title: 'EQP Status Monitor',
              url: '/fdc/monitor/eqp-status-monitor',
              children: []
            },
            {
              title: 'Realtime Monitor',
              url: '/fdc/monitor/realtime-monitor',
              children: []
            }
            // {
            //   title: 'Lot History',
            //   url: '/fdc/monitor/lot-history',
            //   children: []
            // },
            // {
            //   title: 'Event History',
            //   url: '/fdc/monitor/event-history',
            //   children: []
            // },
            // {
            //   title: 'EQP Alarm History',
            //   url: '/fdc/monitor/eqp-alarm-history',
            //   children: []
            // }
          ]
        },
        {
          title: 'Analysis',
          menutTitle: 'Analysis',
          url: '/fdc/analysis',
          progrmClass: 'analysis',
          children: [
            // {
            //   title: 'Trend Analysis',
            //   url: '/fdc/analysis/trend-analysis',
            //   children: []
            // },
            {
              title: 'EQP History',
              url: '/fdc/analysis/eqp-history',
              children: []
            },
            {
              title: 'Lot History',
              url: '/fdc/analysis/lot-history',
              children: []
            },
            {
              title: 'Parameter Analysis',
              url: '/fdc/analysis/parameter-analysis',
              children: []
            },
            {
              title: 'Summary Analysis',
              url: '/fdc/analysis/summary-analysis',
              children: []
            },
            // {
            //   title: 'SPC Analysis',
            //   url: '/fdc/analysis/spc-analysis',
            //   children: []
            // },
            {
              title: 'Multivariate Analysis',
              url: '/fdc/analysis/multivariate-analysis',
              children: []
            },
            {
              title: 'EQP Comparison Analysis',
              url: '/fdc/analysis/eqp-comparison-analysis',
              children: []
            }
            // {
            //   title: 'Change Comparison Analysis',
            //   url: '/fdc/analysis/change-comparison-analysis',
            //   children: []
            // },
            // {
            //   title: 'Parameter Correlation Analysis',
            //   url: '/fdc/analysis/parameter-correlation-analysis',
            //   children: []
            // }
          ]
        },
        {
          title: 'Model',
          menutTitle: 'Model',
          url: '/fdc/model',
          progrmClass: 'model',
          children: [
            {
              title: 'Set-Point Model',
              url: '/fdc/model/set-point-model',
              children: []
            },
            {
              title: 'Formula Model',
              url: '/fdc/model/formula-model',
              children: []
            },
            {
              title: 'Multivariate Model',
              url: '/fdc/model/multivariate-model',
              children: []
            },
            // {
            //   title: 'SPC Rule',
            //   url: '/fdc/model/spc-rule',
            //   children: []
            // },
            // {
            //   title: 'SPC Model',
            //   url: '/fdc/model/spc-model',
            //   children: []
            // }
            {
              title: 'SPC Rule',
              url: '/fdc/model/spc-rule-manager',
              children: []
            },
            {
              title: 'SPC Mail',
              url: '/fdc/model/spc-mail-manager',
              children: []
            },
            {
              title: 'SPC Model',
              url: '/fdc/model/spc-model-manager',
              children: []
            },
            {
              title: 'SPC Analysis',
              url: '/fdc/model/spc-analysis',
              children: []
            },
            {
              title: 'SPC Model Status',
              url: '/fdc/model/spc-model-status',
              children: []
            },
            {
              title: 'Fault Action Plan',
              url: '/fdc/model/fault-action-plan',
              children: []
            }
            // {
            //   title: 'Change Detection Plan',
            //   url: '/fdc/detection/change-detection-plan',
            //   children: []
            // },
            // {
            //   title: 'Auto Modeling Plan',
            //   url: '/fdc/detection/auto-modeling-plan',
            //   children: []
            // }
          ]
        },
        // {
        //   title: 'Classification',
        //   menutTitle: 'Class',
        //   url: '/fdc/classification',
        //   progrmClass: 'classification',
        //   children: [
        //     {
        //       title: 'Fault Classification',
        //       url: '/fdc/classification/fault-classification',
        //       children: []
        //     },
        //     {
        //       title: 'Fault Class Register',
        //       url: '/fdc/classification/fault-class-register',
        //       children: []
        //     }
        //   ]
        // },
        // {
        //   title: 'SPC',
        //   menutTitle: 'SPC',
        //   url: '/fdc/spc',
        //   progrmClass: 'spc',
        //   children: [
        //     {
        //       title: 'SPC Rule Manager',
        //       url: '/fdc/spc/spc-rule-manager',
        //       children: []
        //     },
        //     {
        //       title: 'SPC Mail Manager',
        //       url: '/fdc/spc/spc-mail-manager',
        //       children: []
        //     },
        //     {
        //       title: 'SPC Model Manager',
        //       url: '/fdc/spc/spc-model-manager',
        //       children: []
        //     },
        //     {
        //       title: 'SPC Analysis',
        //       url: '/fdc/spc/spc-analysis',
        //       children: []
        //     },
        //     {
        //       title: 'SPC Model Status',
        //       url: '/fdc/spc/spc-model-status',
        //       children: []
        //     }
        //   ]
        // },
        // {
        //   title: 'OCAP',
        //   menutTitle: 'OCAP',
        //   url: '/fdc/ocap',
        //   progrmClass: 'ocap',
        //   children: [
        //     {
        //       title: 'EQP OCAP',
        //       url: '/fdc/ocap/eqp-ocap',
        //       children: []
        //     },
        //     {
        //       title: 'OCAP Analysis',
        //       url: '/fdc/ocap/ocap-analysis',
        //       children: []
        //     },
        //     {
        //       title: 'OCAP Code',
        //       url: '/fdc/ocap/ocap-code',
        //       children: []
        //     },
        //     {
        //       title: 'OCAP User Info',
        //       url: '/fdc/ocap/ocap-user-info',
        //       children: []
        //     }
        //   ]
        // },
        {
          title: 'Report',
          menutTitle: 'Report',
          url: '/fdc/report',
          progrmClass: 'report',
          children: [
            // {
            //   title: 'OCAP Report',
            //   url: '/fdc/report/ocap-report',
            //   children: []
            // },
            // {
            //   title: 'OCAP Statistics',
            //   url: '/fdc/report/ocap-statistics',
            //   children: []
            // },
            // {
            //   title: 'SPC Statistics',
            //   url: '/fdc/report/spc-statistics',
            //   children: []
            // }
            {
              title: 'Fault Analysis Report',
              url: '/fdc/report/fault-analysis-report',
              children: []
            },
            {
              title: 'Fault Action History',
              url: '/fdc/report/fault-action-history',
              children: []
            },
            {
              title: 'EQP Alarm History',
              url: '/fdc/report/eqp-alarm-history',
              children: []
            }
          ]
        },
        {
          title: 'Admin',
          menutTitle: 'Admin',
          url: '/fdc/admin',
          progrmHist: '/FDC/Admin',
          progrmClass: 'management',
          children: [
            // {
            //   title: 'System Manager',
            //   url: '/fdc/admin/system-manager',
            //   children: []
            // },
            // {
            //   title: 'System Monitor',
            //   url: '/fdc/admin/system-manager',
            //   children: []
            // },
            // {
            //   title: 'Info Change History',
            //   url: '/fdc/admin/info-change-history',
            //   children: []
            // },
            {
              title: 'Host Manager',
              url: '/fdc/admin/host-manager',
              children: []
            },
            // {
            //   title: 'User Manager',
            //   url: '/fdc/admin/user-manager',
            //   children: []
            // },
            // {
            //   title: 'Menu Manager',
            //   url: '/fdc/admin/menu-manager',
            //   children: []
            // },
            {
              title: 'Code Manager',
              url: '/fdc/admin/code-manager',
              children: []
            },
            // {
            //   title: 'Info Use Manager',
            //   url: '/fdc/admin/info-use-manager',
            //   children: [
            //     // {
            //     //   title: 'Use Info Manager',
            //     //   url: '/fdc/management/use-info-manager',
            //     //   children: []
            //     // },
            //     {
            //       title: 'Fab Use Info Manager',
            //       url: '/fdc/admin/fab-use-info-manager',
            //       children: []
            //     },
            //     {
            //       title: 'EQP Use Info Manager',
            //       url: '/fdc/admin/eqp-use-info-manager',
            //       children: []
            //     },
            //     {
            //       title: 'Recipe Use Info Manager',
            //       url: '/fdc/admin/recipe-use-info-manager',
            //       children: []
            //     },
            //     {
            //       title: 'Parameter Use Info Manager',
            //       url: '/fdc/admin/parameter-use-info-manager',
            //       children: []
            //     },
            //     {
            //       title: 'Event Use Info Manager',
            //       url: '/fdc/admin/event-use-info-manager',
            //       children: []
            //     }
            //   ]
            // },
            // {
            //   title: 'Virtual EAP Manager',
            //   url: '/fdc/admin/virtual-eap-manager',
            //   children: []
            // },
            {
              title: 'Virtual Manager',
              url: '/fdc/admin/virtual-manager', // NOTE: virtaul-eap-manager component 사용
              children: []
            }
          ]
        },
        {
          title: 'Dynamic Layout',
          menutTitle: 'Layout',
          url: '/fdc/dynamic-layout',
          progrmClass: 'dynamic-layout',
          children: [
            {
              title: 'Layout Manager',
              url: '/fdc/dynamic-layout/dynamic-layout',
              children: []
            },
            {
              title: 'Custom Layout',
              url: '/fdc/dynamic-layout/custom-layout',
              children: []
            }
          ]
        },
        {
          title: 'Component Sample',
          menutTitle: 'Component',
          url: '/fdc/component-sample',
          progrmClass: 'component-sample',
          children: [
            {
              title: 'Button Sample',
              url: '/component-sample/button-sample',
              children: []
            },
            {
              title: 'Modal Sample',
              url: '/component-sample/modal-sample',
              children: []
            },
            {
              title: 'Loading Bar Sample',
              url: '/component-sample/loadingbar-sample',
              children: []
            },
            {
              title: 'Chart Sample',
              url: '/component-sample/chart-sample',
              children: []
            },
            {
              title: 'Grid Sample',
              url: '/component-sample/grid-sample',
              children: []
            },
            {
              title: 'auto-encoder-analysis',
              url: '/component-sample/auto-encoder-analysis',
              children: []
            }
          ]
        }
      ],

      subDomain: 'localhost',
      subDomains: {
        fdc: 'fdc'
      }
    }
  }
}
